<app-loader *ngIf="pageLoader"></app-loader>
<app-error-message *ngIf="errorMessage" (try)="tryAgain()"></app-error-message>
<div class="container" *ngIf="data && !pageLoader">
  <h2 class="text-center">Control de versiones tipos de venta</h2>
  <div class="rp-tableST">
    <table mat-table [dataSource]="data.reverse() | slice:lowValue : highValue" class="custom_tableST text-center">
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Fecha </th>
        <td mat-cell *matCellDef="let element"> {{ element.registerLastModifiedDate || " - " }} </td>
      </ng-container>

      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Versión </th>
        <td mat-cell *matCellDef="let element"> {{ element.version || " - " }} </td>
      </ng-container>

      <ng-container matColumnDef="plantilla">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Plantilla </th>
        <td mat-cell *matCellDef="let element"> {{ element.name.toUpperCase() || " - "}} </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Estado </th>
        <td mat-cell *matCellDef="let element"> {{ element.status || " - " }} </td>
      </ng-container>

      <ng-container matColumnDef="ambiente" class="text-center">
        <th mat-header-cell *matHeaderCellDef> Ambiente </th>
        <td mat-cell *matCellDef="let element"> {{ element.environment || " - "}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <app-paginator [totalPages]="totalPages" [totalElements]="totalElements" (change)="newRequest()" *ngIf="data.length > 0"></app-paginator>
</div>
